function track(event, data) {
  if (!window.fbq) {
    return;
  }

  try {
    window.fbq('track', event, data);
  } catch (err) {
    // Silence!
  }
}

export default { track };



// WEBPACK FOOTER //
// ./src/lib/facebook.js